const colors = {
  background: "#ffffff",
  foreground: "oklch(0.145 0 0)",
  card: "#ffffff",
  cardForeground: "oklch(0.145 0 0)",
  primary: "#030213",
  secondary: "#F2F2F6",
  accent: "#e9ebef",
  destructive: "#d4183d",
  muted: "#ececf0",
  border: "#E6E8EE",

  brand: {
    orange: "#FF6600",
    orangeLight: "#FF8533",
    orangeDark: "#E65C00",
  },
  neutral: {
    bgLight: "#F8F8F8",
    textPrimary: "#222222",
    textSecondary: "#666666",
    textHelper: "#999999",
  },
  inputBackground: "#F3F3F5",
};
export default colors;
